import { jsxs as t, jsx as C } from "react/jsx-runtime";
const s = ({
  size: r = 48,
  color: n = "currentColor",
  strokeWidth: o = 1.5,
  ...e
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    viewBox: "0 0 48 48",
    fill: "none",
    ...e,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M39 44C39.7957 44 40.5587 43.6839 41.1213 43.1213C41.6839 42.5587 42 41.7956 42 41C42 40.2044 41.6839 39.4413 41.1213 38.8787C40.5587 38.3161 39.7957 38 39 38C38.2044 38 37.4413 38.3161 36.8787 38.8787C36.3161 39.4413 36 40.2044 36 41C36 41.7956 36.3161 42.5587 36.8787 43.1213C37.4413 43.6839 38.2044 44 39 44ZM19 44C19.7957 44 20.5587 43.6839 21.1213 43.1213C21.6839 42.5587 22 41.7956 22 41C22 40.2044 21.6839 39.4413 21.1213 38.8787C20.5587 38.3161 19.7957 38 19 38C18.2044 38 17.4413 38.3161 16.8787 38.8787C16.3161 39.4413 16 40.2044 16 41C16 41.7956 16.3161 42.5587 16.8787 43.1213C17.4413 43.6839 18.2044 44 19 44Z",
          fill: n,
          stroke: n,
          strokeWidth: o,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M10 8H44L40 30M10 8L14 30H40M10 8C9.666 6.666 8 4 4 4M40 30C36.2505 30 14.625 30 14.625 30C8.99999 33.375 6.74999 38 10.46 38H39",
          stroke: n,
          strokeWidth: o,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M23.25 19H27.25M27.25 19H31.25M27.25 19V15M27.25 19V23",
          stroke: n,
          strokeWidth: o,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  s as ShoppingCartIcon
};
